import { COACH_ROUTE_INDEX } from '~/constants/routes/coach';
import { UNIFIED_ROUTE_LOGIN } from '~/constants/routes/unified';
import { UnifiedSavedEntityType } from '~/graphql/generated/graphql';
import { parseSelectedEntityFromQuery } from '~/utils/unified/selectedEntity';

const EXPLORE_CONTENT_ENTITY_TYPES = new Set<UnifiedSavedEntityType>([
  UnifiedSavedEntityType.LearningAsset,
  UnifiedSavedEntityType.LearningAssetCollection,
]);

export const useOnboardingCompletion = () => {
  const route = useRoute();
  const { triggerPostLoginRedirect } = usePostLoginRedirect();
  const { userHasRequiredRole } = usePlatformAppConfig(route.path);
  const { user } = useAuth();
  const configStore = useConfigStore();

  // A schools-cluster account is unusable until the student joins their school. The join, with its
  // per-school terms, is the /login card's school step, which resumes any signed-in student who
  // lacks the role.
  const needsSchoolJoin = () => configStore.isSchoolsCluster && !(user.value && userHasRequiredRole(user.value));

  const completeOnboarding = async () => {
    if (needsSchoolJoin()) {
      await navigateTo({ path: UNIFIED_ROUTE_LOGIN, query: route.query }, { replace: true });
      return;
    }

    const selectedEntity = parseSelectedEntityFromQuery(route.query);
    if (selectedEntity && EXPLORE_CONTENT_ENTITY_TYPES.has(selectedEntity.entityType)) {
      await navigateTo(COACH_ROUTE_INDEX, { replace: true });
      return;
    }

    await triggerPostLoginRedirect();
  };

  return { completeOnboarding };
};
